const n = (e, t = !0) => {
  const a = t ? " " : " ";
  return e.replace(/\s+/g, "").replace(/([A-Z\d]{4}(?!$))/gi, `$1${a}`);
}, r = (e) => {
  switch (e) {
    // Explicit list of copyable account fields
    case "iban":
    case "accountNumber":
    case "routingNumber":
    case "sortCode":
      return !0;
    // Explicit list of non-copyable account fields
    // Items can be moved from this list to the list of copyable fields if necessary
    // The `region` field and other unknown fields (default case) are also considered non-copyable
    case "region":
    default:
      return !1;
  }
}, u = (e, t) => r(e) ? t : void 0, o = (e, t) => {
  switch (e) {
    case "iban":
      return t && n(t);
    default:
      return t;
  }
}, s = (e) => {
  switch (e) {
    case "region":
      return "capital.bankCountryOrRegion";
    case "iban":
      return "capital.bankAccountIban";
    case "accountNumber":
      return "capital.bankAccountNumber";
    case "routingNumber":
      return "capital.bankRoutingNumber";
    case "sortCode":
      return "capital.bankSortCode";
    default:
      return e;
  }
};
export {
  o as getAccountFieldFormattedValue,
  u as getAccountFieldTextToCopy,
  s as getAccountFieldTranslationKey
};
